import * as R from 'ramda'
import { Offer, Opportunity, ClientFrontlineConfig, Building } from '../../../../types/types'
// //import { CurrentOffer } from '../../state/current-offer'
// import { enableEscalationOffer, resetEscalationOffer } from '../../nemo/offering/recommendation'
// import { CommercialTermKey } from 'nemo-pricing'
// import { FrontlineConfig } from '../../state/frontline-config'
// import { getUpdatedOfferFields } from '../../nemo/offer/reset'
import { getEquipmentForOffer } from '../../../common/contract-utils'
import { getEquipmentType } from '../../../common/common-utils'
import { getEquipmentDataFromPreviousContract } from '../../../common/offer'
// import { formatPrice } from '../../nemo/pricing/utils'
// import { round } from '../../../../common/prices'
// import { resetGroups, updateAssessmentMethod } from '../../nemo/offer/assessment-selection'
// import { PriceScoper, priceEstimationScoper } from '../OfferWizard/Price/priceScoper'
// import { resetEscalationFlowOfferPriceEstimation, setOfferPriceEstimation } from '../../nemo/offer/price-estimation'
// import { resetSelectedInteractionRating, setInteractionScope } from '../../nemo/offer/interaction-scope'
// import { Offering } from '../../nemo/offering/types'
// import { setTotalDiscountPercentage } from '../OfferWizard/Price/discount'
// import { getAssessmentProgress } from '../../../../client/js/nemo/assessment/assessment-progress'
// // Escalation flow gets enabled only if it satisfies the following
// // - Only One Active contract
// // - Opportunity should be Renegotiation or SDB Renegotiation
// // - Annual Contract value and annual price should be more than 0
// // - Document type should be 'YWV'
// // - Option C or Option AC is set in MBS Renego princing model
// // - Standard Assessment is deactivated for this Frontline in MBS
// // - Consolidated total of all equipment should be same as contract annualValue
// // - Previous tenders created should not have a standard assessment
// // - Contract type is one of these ["06","07","08","11","12","13","14","15"]
// export function isEscalationFlowEnabled(
//   offer: Offer,
//   frontlineConfig: ClientFrontlineConfig,
//   excludeEquipmentMatching: boolean = false
// ) {
//   const escalationContractTypeCode = ['06', '07', '08', '11', '12', '13', '14', '15', '20', '21', '22', '23', '24']
//   const { opportunity, isEquipmentEnabledInOffer, contractEquipmentsTotalAnnualValue } = offer
//   const { contracts } = opportunity
//   const contract = contracts ? R.head(contracts) : null
//   if (contract) {
//     return (
//       contracts &&
//       contracts.length === 1 &&
//       !contract.expired &&
//       isRenegotiationTypeOppCategory(offer) &&
//       escalationContractTypeCode.includes(contract.contractType) &&
//       escalationContractTypeCode.includes(contract.rushContractTypeCode) &&
//       contract.annualContractValue > 0 &&
//       contract.documentType === 'YWV' &&
//       (frontlineConfig.renegotiation.pricingModel === 'optionC' ||
//         frontlineConfig.renegotiation.pricingModel === 'optionAC') &&
//       (excludeEquipmentMatching || doesOfferHasSameNoOfEquipment(offer)) &&
//       round(contract.annualContractValue) === round(contractEquipmentsTotalAnnualValue || 0) &&
//       !frontlineConfig.enabledAssessmentMethod.includes('standard') &&
//       !previousVersionStandardOfferExists(offer) &&
//       isEquipmentEnabledInOffer
//     )
//   }
//   return false
// }

// export function isEscalationActiveAndEnabled(offer: Offer, frontlineConfig: ClientFrontlineConfig): boolean {
//   return !!(offer.isEscalationFlow.active && isEscalationFlowEnabled(offer, frontlineConfig))
// }

export function isEquipmentEnabled(offer: Offer, frontlineConfig: ClientFrontlineConfig) {
  const frontlineEquipmentType = frontlineConfig.enabledEquipment.map(equipCode => getEquipmentType(equipCode))
  const { buildings } = offer.opportunity
  const equipmentInOpportunity = R.chain(building => building.equipment.map(e => e.equipmentCategory), buildings)
  return (
    R.uniq(equipmentInOpportunity).filter(equipmentType => frontlineEquipmentType.includes(equipmentType)).length ===
    R.uniq(equipmentInOpportunity).length
  )
}

// function previousVersionStandardOfferExists(offer: Offer) {
//   return offer.previousVersions.some(version => version.assessmentMethod === 'standard') || false
// }

export function getNumberOfEquipmentsInOpportunity(opportunity: Opportunity) {
  const { buildings } = opportunity
  return R.chain(building => building.equipment.filter(e => e.equipmentCategory), buildings).length
}

export function getNumberOfEquipmentsInOffer(buildings: Building[]) {
  return R.chain(building => building.details.equipment.filter(e => e.equipmentCategory), buildings).length
}

export function getContractEquipmentsTotalAnnualValue(offer: Offer) {
  const equipmentList = getEquipmentForOffer(offer)
  const offerings = equipmentList.map(e => getEquipmentDataFromPreviousContract(offer, e.id))
  return offerings.reduce(
    (totalAnnualValue, equipment) =>
      totalAnnualValue + (equipment && equipment.annualValue ? equipment.annualValue : 0),
    0
  )
}

// export function resetEscalationFlowOffer(offer: Offer) {
//   const { opportunity } = offer
//   const frontlineConfig = FrontlineConfig.get()

//   CurrentOffer.update(_offer => R.merge(_offer, getUpdatedOfferFields(offer, frontlineConfig)))
//   if (opportunity && opportunity.contracts) {
//     const contract = R.head(opportunity.contracts)
//     if (contract) {
//       CurrentOffer.update(
//         R.pipe(
//           enableEscalationOffer('active', false),
//           enableEscalationOffer('rushContractType', ''),
//           enableEscalationOffer('numberOfEquipments', 0),
//           resetSelectedInteractionRating(frontlineConfig)
//         )
//       )
//     }
//   }
//   updateVasDiscountEquipmentPrice(0, offer.prices)
//   setEscalationFlowOffer('escalationVasDiscountedPrices', 0)
//   setEscalationFlowOffer('escalationVasDiscountedPercentage', 0)
//   CurrentOffer.update(resetEscalationOffer())
//   return CurrentOffer.get()
// }

// export function updateEscalationFlowOffer(offer: Offer) {
//   const { opportunity, isEscalationFlow } = offer
//   const frontlineConfig = FrontlineConfig.get()
//   if (offer.assessmentMethod === 'standard') {
//     updateAssessmentMethod(opportunity.id, 'grouped', frontlineConfig, false)
//   }
//   setOfferPriceEstimation(offer)
//   CurrentOffer.update(_offer => R.merge(_offer, getUpdatedOfferFields(offer, frontlineConfig)))
//   if (opportunity && opportunity.contracts) {
//     const contract = R.head(opportunity.contracts)
//     if (contract) {
//       CurrentOffer.update(
//         R.pipe(
//           enableEscalationOffer('active', true),
//           enableEscalationOffer('rushContractType', contract.rushContractTypeCode),
//           enableEscalationOffer('numberOfEquipments', contract.numberOfEquipments)
//         )
//       )
//       if (isEscalationWithVasAddendumOffer(undefined, true)) {
//         hasMoreGroups(offer) && resetGroups(true)
//         if (R.isEmpty(offer.interaction) || offer.selectedInteractionRating !== 'value_added_services_addendum') {
//           CurrentOffer.update(
//             R.pipe(setInteractionScope('value_added_services_addendum' as InteractionScope, frontlineConfig))
//           )
//         }
//       }
//       CurrentOffer.update(
//         R.pipe(
//           setCommercialTerm('VKBUR', contract.salesOffice),
//           setCommercialTerm('VKGRP', contract.salesGroup),
//           setCommercialTerm('ZTERM', contract.paymentTerm),
//           setCommercialTerm('AUGRU', contract.orderReason ? contract.orderReason : '0'),
//           setCommercialTerm('VKUESCH', contract.cancellationProcedure)
//         )
//       )
//       if (!isEscalationFlow.active) {
//         CurrentOffer.update(
//           (currentOffer: Offer): Offer => ({
//             ...currentOffer,
//             isContractStartDateAtEquipmentLevel: false,
//             isBillingPlanAtEquipmentLevel: false,
//             isOrderReasonAtEquipmentLevel: false,
//             priceEstimation: []
//           })
//         )
//       }
//     }
//   }
// }

// export const updateVasDiscountEquipmentPrice = (
//   editedVasAnnualPercentage: number,
//   offerPrices: Price[],
//   onlyPriceUpdate: boolean = false
// ) => {
//   const prices = onlyPriceUpdate ? offerPrices : [...setTotalDiscountPercentage(editedVasAnnualPercentage, offerPrices)]
//   CurrentOffer.update(
//     (currentOffer: Offer): Offer => ({
//       ...currentOffer,
//       prices
//     })
//   )
// }

// export const getEscalationFlowEquipmentPrice = (
//   equipmentId: string | null,
//   offer: Offer,
//   language: string,
//   currency: string
// ) => {
//   try {
//     if (equipmentId) {
//       const { isEscalationFlow } = offer
//       const equipmentContractData = getEquipmentDataFromPreviousContract(offer, equipmentId)
//       if (equipmentContractData && equipmentContractData.annualValue) {
//         const price =
//           equipmentContractData.annualValue +
//           (equipmentContractData.annualValue * isEscalationFlow.escalatedPercentage) / 100
//         return formatPrice(price, language, currency)
//       }
//     }
//     return ''
//   } catch (e) {
//     return ''
//   }
// }

// export function setEscalationFlowCommercialTerm(key: CommercialTermKey, value: string) {
//   CurrentOffer.update(setCommercialTerm(key, value))
// }

// export function setEscalationFlowOffer(key: string, value: any) {
//   CurrentOffer.update(enableEscalationOffer(key, value))
// }

// export function resetEscalationPriceEstimation() {
//   CurrentOffer.update(resetEscalationFlowOfferPriceEstimation)
// }

// export function getEscalationVatPrice(annualPrice: number, vat: number) {
//   return round(annualPrice * ((100 + vat) / 100) - annualPrice)
// }

// export function doesOfferHasSameNoOfEquipment(offer: Offer): boolean {
//   const {
//     opportunity: { contracts },
//     equipmentsInOpportunity,
//     equipmentsInOffer
//   } = offer
//   const contract = contracts ? R.head(contracts) : null
//   return (
//     contract != null &&
//     equipmentsInOpportunity === contract.numberOfEquipments &&
//     equipmentsInOffer === contract.numberOfEquipments
//   )
// }

// export function isRenegotiationTypeOppCategory(offer: Offer): boolean {
//   const escalationOpportunityCategories = ['Renegotiation', 'SDB Renegotiation']
//   const {
//     opportunity: { opportunityCategory }
//   } = offer
//   return escalationOpportunityCategories.includes(opportunityCategory)
// }

export function getEquipmentCountChanges(
  opportunity: Opportunity,
  buildings: Building[],
  offer: Offer,
  frontlineConfig: ClientFrontlineConfig
) {
  return {
    equipmentsInOpportunity: getNumberOfEquipmentsInOpportunity(opportunity),
    equipmentsInOffer: getNumberOfEquipmentsInOffer(buildings),
    isEquipmentEnabledInOffer: isEquipmentEnabled(offer, frontlineConfig),
    contractEquipmentsTotalAnnualValue: getContractEquipmentsTotalAnnualValue(offer)
  }
}

// export function savePriceEstimation(newPrices: ReadonlyArray<PriceEstimation>) {
//   const priceScoper = PriceScoper(false)
//   const annualPriceEstimations = newPrices.map(priceEstimationScoper(priceScoper.unscope))
//   CurrentOffer.update((offer: Offer) => ({ ...offer, priceEstimation: annualPriceEstimations }))
// }

// export const isEscalationWithVasAddendumOffer = (
//   offer: Offer | undefined = CurrentOffer.get(),
//   isGroupCreation: boolean = false
// ) => {
//   const frontlineConfig = FrontlineConfig.get()
//   const contract = offer.opportunity.contracts ? R.head(offer.opportunity.contracts) : null
//   if (!frontlineConfig || !contract) {
//     return false
//   }
//   const {
//     renegotiation: {
//       optionC: { isEscalationFlowVasAddendumEnabled }
//     }
//   } = frontlineConfig
//   // Add option to check the frontline enabledment of vas in escalation flow
//   return (
//     isGroupCreation ||
//     (isEscalationActiveAndEnabled(offer, frontlineConfig) &&
//       isOnlyElevatorOpportunity(offer.opportunity.buildings) &&
//       contract &&
//       contract.is24_7ConnectEnabled &&
//       isEscalationFlowVasAddendumEnabled)
//   )
// }

// export const isOnlyElevatorOpportunity = (buildings: OpportunityBuilding[]) =>
//   R.chain(
//     building => building.equipment.filter(e => e.equipmentCategory === 'door' || e.equipmentCategory === 'escalator'),
//     buildings
//   ).length === 0

// export const numberOfEscalationWizardPages = {
//   totalPagesWithEscalationVasAddendum: 4,
//   totalPagesWithoutEscalationVasAddendum: 2
// }

// const hasMoreGroups = (offer: Offer) => {
//   const groupCount = R.keys(offer.equipmentGroups).length
//   return groupCount > 1
// }

// export const hasMultipleGroupsInOffering = (offering: Offering) => {
//   const groupCount = offering && 'groups' in offering ? R.keys(offering.groups).length : 0
//   return groupCount > 1
// }

// export const offerWithVASAddendumAndValidData = (offerData?: Offer) => {
//   const offer = offerData ? offerData : CurrentOffer.get()
//   return isEscalationWithVasAddendumOffer(offer) ? !isPrepareDataValidForRenego(offer) : false
// }
// export function isPrepareDataValidForRenego(offer: Offer): boolean {
//   const frontlineConfig = FrontlineConfig.get()
//   const assessmentProgress = getAssessmentProgress(offer, frontlineConfig)
//   const validElements: ValidElements = {
//     buildings: assessmentProgress.isValidMasterData('building'),
//     elevators: assessmentProgress.isValidMasterData('elevator')
//   }
//   return R.all(e => e === true, Object.values(validElements))
// }
